import { SUPPLIERS_URL } from '../constants'; // Define the base URL for suppliers API
import { apiSlice } from './apiSlice';

export const suppliersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all suppliers with filtering and pagination
    getSuppliers: builder.query({
      query: ({ keyword = '', pageNumber = 1 }) => ({
        url: SUPPLIERS_URL,
        params: { keyword, pageNumber }, // Enable filtering and pagination
      }),
      keepUnusedDataFor: 5, // Cache unused data for 5 seconds
      providesTags: ['Suppliers'], // Tag used for cache invalidation
    }),

    // Fetch a single supplier by ID
    getSupplierDetails: builder.query({
      query: (supplierId) => ({
        url: `${SUPPLIERS_URL}/${supplierId}`,
      }),
      keepUnusedDataFor: 5, // Cache unused data for quick access
    }),

    // Create a new supplier
    createSupplier: builder.mutation({
      query: (data) => ({
        url: SUPPLIERS_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Suppliers'], // Refresh supplier list cache
    }),

    // Update an existing supplier by ID
    updateSupplier: builder.mutation({
      query: (data) => ({
        url: `${SUPPLIERS_URL}/${data.supplierId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Suppliers'], // Refresh supplier list after update
    }),

    // Delete a supplier by ID
    deleteSupplier: builder.mutation({
      query: (supplierId) => ({
        url: `${SUPPLIERS_URL}/${supplierId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Suppliers'], // Refresh supplier list cache
    }),

    // Fetch top suppliers (based on specific criteria such as sales)
    getTopSuppliers: builder.query({
      query: () => `${SUPPLIERS_URL}/top`,
      keepUnusedDataFor: 5, // Cache unused data for quick access
    }),
  }),
});

export const {
  useGetSuppliersQuery, // Hook to fetch all suppliers
  useGetSupplierDetailsQuery, // Hook to fetch details of a specific supplier
  useCreateSupplierMutation, // Hook to create a supplier
  useUpdateSupplierMutation, // Hook to update a supplier
  useDeleteSupplierMutation, // Hook to delete a supplier
  useGetTopSuppliersQuery, // Hook to fetch top suppliers
} = suppliersApiSlice;